// extracted by mini-css-extract-plugin
module.exports = {"nextLine":"styles-module--next-line--2zL4m","blankLine":"styles-module--blank-line--1iGhI"};